export let labelUtils = {
  getDisplayProperty: (fieldEle) => {
    switch (fieldEle?.["display-labelposition"]) {
      case "top":
      default:
        return "block";
      case "left":
      case "right":
      case "center":
        return "flex";
    }
  },
  getLabelStyle: (fieldEle) => {
    switch (fieldEle?.["display-labelposition"]) {
      case "top":
      default:
        return { textAlign: "left", width: "100%" };
      case "left":
        return { textAlign: "left", width: "30%" };
      case "right":
        return { textAlign: "right", width: "30%" };
      case "center":
        return { textAlign: "center", width: "30%" };
    }
  },
  getElementWidth: (fieldEle) => {
    switch (fieldEle?.["display-labelposition"]) {
      case "top":
      case "placeholder":
      default:
        return "100%";
      case "left":
      case "right":
      case "center":
        return "70%";
    }
  },
};
export let positionUtils = {
  getGridColumsforBoxes: (fieldEle) => {
    let cols = fieldEle?.["display-noofcolumns"] || "6";
    return `repeat(${cols}, 1fr)`;
  },
};
